export default "__VITE_ASSET__8cc4d5bb__"